/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/imstillyourchild.com/node_modules/lodash/_freeGlobal.js
// module id = 179
// module chunks = 184 185 186